<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Actualizar DAM</h4>
    <button type="button" class="close" aria-label="Close" (click)="_close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body" style="padding: 10px;">
    <form>

        <div class="form-group">
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group row" style="margin-bottom: 0.5rem;">
                        <label for="fname2" style="padding: 0.2em 0em 0em .5em;"
                            class=" col-md-2 control-label col-form-label">Dam:</label>
                        <div class="col-md-4">
                            <input [(ngModel)]="valorDam" style="text-align: center;" class="form-control"
                                name="valorDam" type="text" 
                                maxlength="25"
                                >
                        </div>
                        <span style="color: red; font: sans-serif;">(*)</span>
                    </div>
                    <!-- <div class="form-group row" style="margin-bottom: 0.5rem;">

                        <label for="fname2" style="padding: 0.2em 0em 0em .5em;"
                            class=" col-md-2 control-label col-form-label">Departamento:</label>
                        <div class="col-md-2">
                            <input [(ngModel)]="codDepart" style="text-align: center;" class="form-control" (change)="onChangeDepartamento($event.target.value)"
                                name="codClase" type="text"
                                onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10"
                                disabled>
                        </div>
                        <div class="col-md-7">
                            <select [(ngModel)]="codDepart" tabindex="15" class="custom-select" name="codDepart" 
                                #selectClase (change)="onChangeDepartamento($event.target.value)">
                                <option *ngFor="let claseSele of listaDepartamentos" value="{{claseSele.codigo}}">
                                    {{claseSele.descri}}
                                </option>
                            </select>
                        </div>
                        <span style="color: red; font: sans-serif;">(*)</span>
                    </div>


                    <div class="form-group row" style="margin-bottom: 0.5rem;">
                        <label for="fname2" style="padding: 0.2em 0em 0em .5em;"
                            class=" col-md-2 control-label col-form-label">Provincia:</label>
                        <div class="col-md-2">
                            <input [(ngModel)]="codProv" style="text-align: center;" class="form-control" name="codProv"
                                type="text" (keydown.enter)="onKeyEnterProvincia($event)"
                                (blur)="onBlurProvincia($event)"
                                onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10">
                        </div>
                        <div class="col-md-7">
                            <select id="cboProvincia" [disabled]="disabledprov" [(ngModel)]="codProv" tabindex="15"
                                (change)="onChangeProvincia($event.target.value)" class="custom-select" name="codProv">
                                <option *ngFor="let codigoSele of listaprovincias" value="{{codigoSele.codigo}}">
                                    {{codigoSele.provincia}}
                                </option>
                            </select>
                        </div>
                        <span style="color: red; font: sans-serif;">(*)</span>
                    </div>

                    <div class="form-group row" style="margin-bottom: 0.5rem;">
                        <label for="fname2" style="padding: 0.2em 0em 0em .5em;"
                            class=" col-md-2 control-label col-form-label">Distrito:</label>
                        <div class="col-md-2">
                            <input [(ngModel)]="codDist" style="text-align: center;" class="form-control" name="codDist"
                                type="text" (keydown.enter)="onKeyEnterDistrito($event)" (blur)="onBlurDistrito($event)"
                                onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10">
                        </div>
                        <div class="col-md-7">
                            <select id="cboDistrito" [disabled]="disableddistr" [(ngModel)]="codDist" tabindex="15"
                                class="custom-select" name="codDist" (change)="onChangeDistrito($event.target.value)">
                                <option *ngFor="let codigoSele of listadistritos" value="{{codigoSele.codigo}}">
                                    {{codigoSele.distrito}}
                                </option>
                            </select>
                        </div>
                        <span style="color: red; font: sans-serif;">(*)</span>
                    </div> -->
                </div>
            </div>

        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-rounded btn-info m-b-15" tabindex="5" (click)="_ok()"><i
            class="fa fa-save"></i> Guardar</button>
    <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="_close()" tabindex="6"><i
            class="fa fa-times-circle"></i> Cancelar</button>
</div>